<template>
  <Loader v-if="loader" />

  <div class="formgrid grid">
    <div class="col-12">
      <div class="card mb-3">
        <h5>Riepilogo Scadenze per Settimana</h5>
        <Chart
          type="bar"
          :data="chartData"
          :options="chartOptions"
          class="h-20rem"
        />
      </div>

      <div v-if="selectedWeekFatture.length > 0 || selectedWeekIncassi.length > 0" class="mt-3">
        <h6>Dettagli per il periodo: {{ selectedWeekRange }}</h6>
        
        <div v-if="selectedWeekFatture.length > 0" class="mb-4">
          <h6 class="text-primary">Uscite</h6>
          <Accordion :multiple="true">
            <AccordionTab
              v-for="(gruppo, index) in selectedWeekFatture"
              :key="'uscita-'+index"
            >
              <template #header>
                <div class="flex justify-content-between align-items-center w-full">
                  <span>{{ gruppo.fornitore }}</span>
                  <span class="font-bold">€ {{ formatNumber(gruppo.totale) }}</span>
                </div>
              </template>


              <DataTable 
                :value="gruppo.fatture" 
                stripedRows
                :paginator="true"
                :rows="10"
                :rowsPerPageOptions="[5,10,20,50]"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              >
                <Column field="numero" header="Numero">
                  <template #body="slotProps">
                    <a href="#" class="text-primary" @click.prevent="openInvoiceDetails(slotProps.data.id)">
                      {{ slotProps.data.numero }}
                    </a>
                  </template>
                </Column>
                <Column field="data_emissione" header="Emissione">
                  <template #body="slotProps">
                    {{ formatDate(slotProps.data.data_emissione) }}
                  </template>
                </Column>
                <Column field="data_scadenza" header="Scadenza">
                  <template #body="slotProps">
                    {{ formatDate(slotProps.data.data_scadenza) }}
                  </template>
                </Column>
                <Column field="totale_fattura" header="Importo">
                  <template #body="slotProps">
                    € {{ formatNumber(slotProps.data.totale_fattura) }}
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </div>

        <div v-if="selectedWeekIncassi.length > 0" class="mt-4">
          <h6 class="text-primary">Incassi</h6>
          <Accordion :multiple="true">
            <AccordionTab
              v-for="(gruppo, index) in selectedWeekIncassi"
              :key="'incasso-'+index"
            >
              <template #header>
                <div class="flex justify-content-between align-items-center w-full">
                  <span>{{ gruppo.agente }}</span>
                  <span class="font-bold">€ {{ formatNumber(calcolaTotaleAgente(gruppo.dettagli)) }}</span>
                </div>
              </template>

              <DataTable 
                :value="gruppo.dettagli" 
                stripedRows
                :paginator="true"
                :rows="10"
                :rowsPerPageOptions="[5,10,20,50]"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              >
              <Column field="numero" header="Numero">
                  <template #body="slotProps">
                    <a href="#" class="text-primary" @click.prevent="openInvoiceDetails2(slotProps.data.numero)">
                      {{ slotProps.data.numero }}
                    </a>
                  </template>
                </Column>
                <Column field="ragsoc" header="Cliente">
                  <template #body="slotProps">
                    <a href="#" class="text-primary" @click.prevent="openInvoiceDetails3(slotProps.data.client_id)">
                      {{ slotProps.data.ragsoc }}
                    </a>
                  </template>
                </Column>
                <Column field="previsione" header="Data Prevista">
                  <template #body="slotProps">
                    {{ formatDate(slotProps.data.previsione) }}
                  </template>
                </Column>
                <Column field="totale_fattura" header="Importo">
                  <template #body="slotProps">
                    € {{ formatNumber(slotProps.data.totale_fattura) }}
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </div>
      </div>

      <div class="card mt-5">
        <div class="grid">
          <div class="col-12">
            <h5>Scadenze fatture</h5>
            <small>Visualizzazione scadenze effettive e previsionali</small>
            
            <div class="flex gap-2 mt-3">
              <Button
                :class="{ 'p-button-outlined': !showPrevisionale }"
                label="Scadenza Previsionale"
                style="margin-right: 8px"
                @click="showPrevisionale = true"
              />
              <Button
                :class="{ 'p-button-outlined': showPrevisionale }"
                label="Scadenza Effettiva"
                @click="showPrevisionale = false"
              />
            </div>
          </div>
        </div>

        <div v-if="usciteRaggruppate.length > 0" class="mt-3">
          <Accordion :multiple="true">
            <AccordionTab
              v-for="(giorno, index) in usciteRaggruppate"
              :key="index"
            >
              <template #header>
                <div class="flex justify-content-between align-items-center w-full">
                  <span>{{ formatDate(giorno.data) }}</span>
                  <span class="font-bold">€ {{ formatNumber(giorno.tot_fatture) }}</span>
                </div>
              </template>

              <div v-for="fornitore in raggruppaPerFornitore(giorno.dettagli)"
                   :key="fornitore.cod_fornitore"
                   class="mb-3">
                <div class="p-3 border-1 surface-border border-round">
                  <div class="flex justify-content-between align-items-center mb-3">
                    <span class="font-bold">{{ fornitore.ragsoc }}</span>
                    <span class="font-bold">€ {{ formatNumber(fornitore.totale) }}</span>
                  </div>

                  <DataTable :value="fornitore.fatture" stripedRows>
                    <Column field="numero" header="Numero">
                      <template #body="slotProps">
                        <a
                          href="#"
                          class="text-primary"
                          @click.prevent="openInvoiceDetails(slotProps.data.id)"
                        >
                          {{ slotProps.data.numero }}
                        </a>
                      </template>
                    </Column>
                    <Column field="data_scadenza" header="Scadenza">
                      <template #body="slotProps">
                        {{ formatDate(slotProps.data.data_scadenza) }}
                      </template>
                    </Column>
                    <Column
                      v-if="showPrevisionale"
                      field="data_previsionale"
                      header="Data Prevista Pagamento"
                    >
                      <template #body="slotProps">
                        {{ formatDate(slotProps.data.data_previsionale) }}
                      </template>
                    </Column>
                    <Column field="totale_fattura" header="Importo">
                      <template #body="slotProps">
                        € {{ formatNumber(slotProps.data.totale_fattura) }}
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </div>
            </AccordionTab>
          </Accordion>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Service from "@/services/ask-pratiche/pratiche-service";
import { ref, getCurrentInstance, onMounted, computed } from "vue";
import Loader from "@/components/Loader.vue";
import SkeletonCustom from "@/components/SkeletonCustom.vue";
import { Chart } from "primevue/chart";

export default {
  components: {
    Loader,
    SkeletonCustom,
    Chart,
  },

  setup() {
    const loader = ref(false);
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new Service(self.$http, self.$eventBus);
    const usciteEffettive = ref([]);
    const uscitePrevisionali = ref([]);
    const showPrevisionale = ref(false);
    const weeklyData = ref([]);
    const chartData = ref({});
    const chartOptions = ref({
      plugins: {
        legend: {
          labels: {
            color: "#495057",
          },
        },
        tooltip: {
          callbacks: {
            label: (context) => {
              let value = context.raw;
              return `Totale: € ${formatNumber(value)}`;
            },
          },
          footer: () => 'Clicca per vedere i dettagli',
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            callback: (value) => "€ " + formatNumber(value),
          },
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      onClick: async (event, elements) => {
        if (elements.length > 0) {
          const index = elements[0].index;
          
          const usciteResponse = await service.getDettaglioUsciteSettimanali(index);
          if (usciteResponse.items.success) {
            selectedWeekFatture.value = raggruppaFatturePerFornitore(usciteResponse.items.fatture);
          }

          const incassiResponse = await service.getDettaglioIncassiSettimanali(index);
          if (incassiResponse.items.success) {
            selectedWeekIncassi.value = incassiResponse.items.incassi_per_agente;
          }

          const weekData = weeklyData.value[index];
          selectedWeekRange.value = `${formatDate(weekData.start_date)} - ${formatDate(weekData.end_date)}`;
        }
      },
      onHover: (event, elements) => {
        event.native.target.style.cursor = elements.length ? 'pointer' : 'default';
      },
      hover: {
        mode: 'index',
        intersect: false
      }
    });
    const selectedWeekFatture = ref([]);
    const selectedWeekIncassi = ref([]);
    const selectedWeekRange = ref("");

    const usciteRaggruppate = computed(() => {
      const dati = showPrevisionale.value ? uscitePrevisionali.value : usciteEffettive.value;
      return dati || [];
    });

    const loadWeeklyData = async () => {
      try {
        const response = await service.getScadenzaFatturePerGrafico();
        if (response.items && response.items.success && response.items.weeks) {
          weeklyData.value = response.items.weeks;
          updateChartData();
        } else {
          console.error("Formato dati non valido:", response);
        }
      } catch (error) {
        console.error("Errore nel caricamento dei dati settimanali:", error);
      }
    };

    const updateChartData = () => {
      if (!weeklyData.value) return;

      chartData.value = {
        labels: weeklyData.value.map(
          (week) => `${formatDate(week.start_date)} - ${formatDate(week.end_date)}`
        ),
        datasets: [
          {
            type: 'bar',
            label: 'Uscite',
            data: weeklyData.value.map((week) => Math.abs(week.totale_uscite || 0)),
            backgroundColor: '#FF6384',
            borderColor: '#FF4444',
            borderWidth: 1,
          },
          {
            type: 'bar',
            label: 'Incassi',
            data: weeklyData.value.map((week) => Math.abs(week.totale_incassi || 0)),
            backgroundColor: '#36A2EB',
            borderColor: '#2196F3',
            borderWidth: 1,
          }
        ]
      };

      chartOptions.value = {
        plugins: {
          legend: {
            labels: {
              color: "#495057",
            },
            position: 'top'
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                let value = context.raw || 0;
                return `${context.dataset.label}: € ${formatNumber(value)}`;
              },
            },
            footer: () => 'Clicca per vedere i dettagli',
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => "€ " + formatNumber(value),
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: async (event, elements) => {
          if (elements.length > 0) {
            const index = elements[0].index;
            
            const usciteResponse = await service.getDettaglioUsciteSettimanali(index);
            if (usciteResponse.items.success) {
              selectedWeekFatture.value = raggruppaFatturePerFornitore(usciteResponse.items.fatture);
            }

            const incassiResponse = await service.getDettaglioIncassiSettimanali(index);
            if (incassiResponse.items.success) {
              selectedWeekIncassi.value = incassiResponse.items.incassi_per_agente;
            }

            const weekData = weeklyData.value[index];
            selectedWeekRange.value = `${formatDate(weekData.start_date)} - ${formatDate(weekData.end_date)}`;
          }
        },
        onHover: (event, elements) => {
          event.native.target.style.cursor = elements.length ? 'pointer' : 'default';
        },
        hover: {
          mode: 'index',
          intersect: false
        }
      };
    };

    onMounted(() => {
      getUsciteFuture();
      loadWeeklyData();
    });

    const getUsciteFuture = () => {
      loader.value = true;
      service
        .getPrevisionalUsciteFuture()
        .then((res) => {
          if (res.items) {
            const fattureGrezze = [];
            
            res.items.scadenza_previsionale.forEach(item => {
              const dettagli = Object.values(item.dettagli || {});
              dettagli.forEach(fattura => {
                fattureGrezze.push({
                  ...fattura,
                  data_scadenza: moment(fattura.data_scadenza).format('YYYY-MM-DD'),
                  data_previsionale: moment(fattura.data_previsionale || fattura.data_scadenza).format('YYYY-MM-DD')
                });
              });
            });

            const raggruppaFatture = (fatture, dataField) => {
              const grouped = {};
              fatture.forEach(fattura => {
                const data = fattura[dataField];
                if (!grouped[data]) {
                  grouped[data] = {
                    data: data,
                    tot_fatture: 0,
                    dettagli: []
                  };
                }
                grouped[data].dettagli.push(fattura);
                grouped[data].tot_fatture += parseFloat(fattura.totale_fattura || 0);
              });
              return Object.values(grouped)
                .sort((a, b) => moment(a.data).diff(moment(b.data)));
            };

            usciteEffettive.value = raggruppaFatture(fattureGrezze, 'data_scadenza');
            uscitePrevisionali.value = raggruppaFatture(fattureGrezze, 'data_previsionale');

          }
        })
        .finally(() => {
          loader.value = false;
        });
    };

    const raggruppaPerFornitore = (dettagli) => {
      if (!dettagli || !Array.isArray(dettagli)) {
        console.error('Dettagli non validi:', dettagli);
        return [];
      }

      
      const fornitori = {};
      dettagli.forEach(fattura => {
        const codFornitore = fattura.cod_fornitore;
        if (!fornitori[codFornitore]) {
          fornitori[codFornitore] = {
            cod_fornitore: codFornitore,
            ragsoc: fattura.ragsoc,
            totale: 0,
            fatture: []
          };
        }
        fornitori[codFornitore].totale += parseFloat(fattura.totale_fattura || 0);
        fornitori[codFornitore].fatture.push(fattura);
      });

      const result = Object.values(fornitori)
        .sort((a, b) => a.ragsoc.localeCompare(b.ragsoc));
      
      return result;
    };

    const formatDate = (date) => {
      return moment(date).locale("it").format("DD MMM YYYY");
    };

    const formatNumber = (number) => {
      return new Intl.NumberFormat("it-IT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number);
    };

    const openInvoiceDetails = (id) => {
      window.open(`/ask/acquisto/fatture/${id}/dettagli`);
    };

    const openInvoiceDetails2 = (numero) => {
      window.open(`/ask/clienti/fatture/${numero}/dettagli`);
    };

    const openInvoiceDetails3 = (client_id) => {
      window.open(`/ask/clienti/${client_id}/dettagli`);
    };

    const raggruppaFatturePerFornitore = (fatture) => {
      const grouped = {};
      fatture.forEach((fattura) => {
        if (!grouped[fattura.nomeFornitore]) {
          grouped[fattura.nomeFornitore] = {
            fornitore: fattura.nomeFornitore,
            totale: 0,
            fatture: [],
          };
        }
        grouped[fattura.nomeFornitore].fatture.push(fattura);
        grouped[fattura.nomeFornitore].totale += parseFloat(fattura.totale_fattura);
      });
      return Object.values(grouped);
    };

    const calcolaTotaleAgente = (dettagli) => {
      return dettagli.reduce((sum, fattura) => 
        sum + parseFloat(fattura.totale_fattura || 0), 0
      );
    };

    return {
      loader,
      usciteRaggruppate,
      showPrevisionale,
      raggruppaPerFornitore,
      formatDate,
      formatNumber,
      openInvoiceDetails,
      openInvoiceDetails2,
      openInvoiceDetails3,
      chartData,
      chartOptions,
      selectedWeekFatture,
      selectedWeekIncassi,
      selectedWeekRange,
      calcolaTotaleAgente,
    };
  },
};
</script>

